import { xcss } from '@atlaskit/primitives';
import styled from '@emotion/styled';
import { token } from '@atlaskit/tokens';

interface ShowEstimateDetailsWrapperProps {
  isDisabled?: boolean;
}

export const entitlementInfoBoxStyles = xcss({
  flexGrow: 1,
});

export const cancelReasonDivStyles = xcss({
  paddingTop: `space.150`,
  paddingBottom: `space.150`,
});

export const ShowDetailsCustomPanelWrapper = styled.div`
  .ppc-custom-panel-v2 {
    background: transparent;

    .ppc-custom-panel-header {
      justify-content: normal;
      font-weight:  ${token('font.weight.regular')}
      color: ${token('color.text.subtle')};
      font-size: ${token('font.size.100')};
      padding: 0;
    }
    .custom-panel-container.expanded {
      border: 0;
    }
  }
`;

const renderDisabledStyle = (props: ShowEstimateDetailsWrapperProps) => {
  if (props.isDisabled) {
    return `> div > div, h4 {
      color: ${token('color.text.disabled')};
    }`;
  }
  return null;
};

export const ShowEstimateDetailsWrapper = styled.div<ShowEstimateDetailsWrapperProps>`
  ${renderDisabledStyle}
`;

export const InstalledAppsCustomPanelWrapper = styled.div`
  padding: 0;

  .ppc-custom-panel-v2 {
    background: transparent;

    .ppc-custom-panel-header {
      justify-content: normal;
      font-weight:  ${token('font.weight.bold')}
      color: ${token('color.text')};
      font-size: ${token('font.size.100')};
      padding: 0;
    }

    .custom-panel-container.expanded {
      border: 0;
    }
  }
`;

export const EntitlementLozenge = styled.div`
  // did this so that initial margin on the lozenge is zero
  margin-left: -4px;
`;
